import { UserRole } from '../entities';

export const userRolesToFilter = [
    UserRole.AccountManager,
    UserRole.AccountManagerTrusted,
    UserRole.Merchant,
    UserRole.TeamLead,
    UserRole.Trader,
    UserRole.Operator
];

export const usersPerPageInitial = 20;

export const noRoleFilter = 'all';

export const usersListLSKey = 'usersListPageParams';
